import RenderIf from 'components/RenderIf/RenderIf';
import { SIDE_NAV_TEST_IDS } from '../../constants';
import { isTopNavSection } from '../../helpers';
import { ISideNavSection } from '../../interfaces';
import SideNavItem from './SideNavItem/SideNavItem';
import './SideNavSection.scss';

interface ISideNavSectionProps {
    section: ISideNavSection;
    isCollapsed: boolean;
    onCollapsedParentClick: (parentId: string) => void;
    openParentIds: Set<string>;
    onOpenParent: (parentId: string) => void;
    onToggleParent: (parentId: string) => void;
}

const SideNavSection = ({
    section,
    isCollapsed,
    onCollapsedParentClick,
    openParentIds,
    onOpenParent,
    onToggleParent,
}: ISideNavSectionProps) => (
    <div data-testid={`SideNavSection-${section.id}`}>
        <RenderIf isTrue={!isCollapsed && Boolean(section.section)}>
            <div className="d-flex align-items-center SideNavSection__header">
                <div className="font-10 text-uppercase text-muted">{section.section}</div>
            </div>
        </RenderIf>

        <RenderIf isTrue={isCollapsed && isTopNavSection(section.id)}>
            <hr aria-hidden data-testid={SIDE_NAV_TEST_IDS.HEADER_DIVIDER} />
        </RenderIf>

        <ul className="list-unstyled mb-0">
            {section.items.map(item => (
                <SideNavItem
                    key={item.id}
                    item={item}
                    isCollapsed={isCollapsed}
                    onCollapsedParentClick={onCollapsedParentClick}
                    openParentIds={openParentIds}
                    onOpenParent={onOpenParent}
                    onToggleParent={onToggleParent}
                />
            ))}
        </ul>
    </div>
);

export default SideNavSection;
